import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import { Arrow } from "../../icons"

const TitleContentList = ({ title, subtitle, richContent, items, link }) => {

  return (
    <section className="title-content-list">
      <div className="title-content-list__inner">
        <div className="title-content-list__wrapper">
          <div className="line line--vertical center-top"></div>

          <div className="title-content-list__title">
            {subtitle && <h3>{parse(subtitle)}</h3>}
            {title && <h2>{parse(title)}</h2>}
            {richContent && <StructuredText data={richContent} />}
            {link?.length > 0 &&
              (<Link
                className="btn btn--orange"
                to={link[0].link[0].externalLink ? link[0].link[0].externalLink : link[0].link[0].internalLink.permalink}
              >
                {link[0].title}
              </Link>)}
          </div>

          <div className="title-content-list__content">
            {title && <h2>{parse(title)}</h2>}
            {items?.length > 0 &&
              <div className="title-content-list__items">
              {items.map((el, i) =>
                (<Link
                    key={i}
                    className="title-content-list__item"
                    to={el.link[0].externalLink ? el.link[0].externalLink : el.link[0].internalLink.permalink}
                  >
                    {el.title}
                    <Arrow />
                  </Link>
                ))}
            </div>}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TitleContentList

export const query = graphql`
    fragment TitleContentListProps on DatoCmsTitleContentList {
      ... on DatoCmsTitleContentList {
        id
        title
        subtitle
        richContent {
          value
        }
        link {
          ...LinkWithTitleProps
        }
        items {
          ...LinkWithTitleProps
        }
      }
    }
`